var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12'],"bottom-space":""}},[_c('v-card',[_c('l-data-table',{attrs:{"headers":_vm.header,"title-text":"计费结果列表","search-text":"请输入车牌号","get-data-func":_vm.getResultList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }